var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"p-4 footer bg-primary text-base-content footer-center text-lg"},[_c('div',[_c('p',[_vm._v(" Copyright © "),_c('span',{ref:"year"}),_vm._v(" - Lucky Tri Bhakti - Made With ❤ ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }